import { Box, Stack } from '@mui/material'

import { SectionHeading } from '@/components/atoms/SectionHeading'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { scaledFontSize } from '@/shared/styles/typography'
import { type SoapSetLine } from '@/features/soap-masters'

// 定型文の中身 (区分 + 本文) の描画。挿入ダイアログと設定ページで同じ見え方にするため
// 1 箇所に置く。差はハンドラだけで、描画はここが唯一の定義。
//
// 全行をそのまま見せる。押した結果がそのまま入るので、抜粋にして
// 「思ったのと違うものが入った」を作らない。

interface Props {
  lines: SoapSetLine[]
  // 文字拡大モードに追従するか。薬歴側 (録音画面) は追従し、portal は追従しない
  // (portal 系テキストは font-scale の対象外 — 01-foundations/font-scale.md)。
  scaled?: boolean
}

export const SoapSetLines = ({ lines, scaled = true }: Props) => (
  <Stack spacing={0} sx={{ mt: 0.25 }}>
    {lines.map((line, i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          gap: 0.75,
          fontSize: scaled ? scaledFontSize('label') : 13,
          color: colorTokens.fg.muted,
        }}
      >
        {/* SOAP 区分は「この行がどこに入るか」を決める唯一の手がかり.
            SoapBody・文字起こしタブと同じ SectionHeading の単一 spec を使う
            (独自の字格を作らない). 区分が無い行でも溝は残す —— 本文の左端が
            行ごとにずれると、束の中で何が並んでいるのか読めなくなる. */}
        <SectionHeading
          sx={{
            flexShrink: 0,
            // 区分の列幅も文字に追従させる (固定 20px だと「大」で
            // EP/CP/OP の 2 文字が枠を越える). sidebar 224×scale と同じ形.
            width: (t) => (scaled ? Math.round(20 * (t.fontScale ?? 1)) : 20),
            lineHeight: 'inherit',
          }}
        >
          {line.soap_type ?? ''}
        </SectionHeading>
        <Box component="span" sx={{ whiteSpace: 'pre-wrap' }}>
          {line.content}
        </Box>
      </Box>
    ))}
  </Stack>
)
